//import { config } from '@fortawesome/fontawesome-svg-core';
//import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import dayjs from 'dayjs';
import { axiosPrivate } from '../hooks/axiosPrivate';
// 
const baseURL = 'https://testapi.royalarabian.com/';
// const baseURL = 'http://localhost:34567/';
const loginUrl = baseURL + 'auth/adminLogin';
const userProfileUrl = baseURL + 'user/listUserById';
const logoutUrl = baseURL + "user/logout";
const userCreateUrl = baseURL + 'user/createUser';
const listAllUsersUrl = baseURL + 'user/listAllUsers';
const userProfileUpdate = baseURL + 'user/userprofileupdate';
const getUserUrl = baseURL + 'user/listUserById';
const deleteUser = baseURL + 'user/deleteUser';
const newAccessJWT = baseURL + "tokens";
const refreshTokenURL = baseURL + "auth/token";
//user Role
const listAllUserRoleUrl = baseURL + 'userrole/listAllRoles';
const userRoleCreateUrl = baseURL + 'userrole/createRole';
const getUserRoleUrl = baseURL + 'userrole/getRolesById';
const userRoleUpdateURL = baseURL + 'userrole/userroleupdate';
const deleteUserRolesURL = baseURL + 'userrole/deleteUserRoles';
//country
const listAllCountryUrl = baseURL + 'country/listallcountries';
const createCountryUrl = baseURL + 'country/createcountry ';
const getCountryUrl = baseURL + 'country/getcountriesbyid';
const deleteCountryURL = baseURL + 'country/deletecountries';
const countryUpdateURL = baseURL + 'country/countriesupdate ';



//product commission
const listAllProductComissionUrl = baseURL + 'productcommission/listallcommissions';
const createProductComissionUrl = baseURL + 'productcommission/createproductcommission ';
const getProductComissionUrl = baseURL + 'productcommission/getcommissionsbyid';
const deleteProductComissionURL = baseURL + 'productcommission/deletecommissions';
const productcomissionUpdateURL = baseURL + 'productcommission/commissionsupdate ';
const approveProductComissionURL = baseURL + 'productcommission/approvecommissions';
const rejectProductComissionURL = baseURL + 'productcommission/rejectcommissions';



//product rates

//create urls
const createProductRatesUrl = baseURL + 'productbaserates/createproductbaserate';
const createAdultRatesUrl = baseURL + 'adultprice/createadultprice';
const createHourRatesUrl = baseURL + 'hourprice/createhourprice';
const createVehicleRatesUrl = baseURL + 'vehicleprice/createvehicleprice';
const createChildRatesUrl = baseURL + 'childprice/createchildprice';
const createInfantRatesUrl = baseURL + 'infantprice/createinfantprice';
const createSuplementRatesUrl = baseURL + 'supplement/createsupplement';
const createPromotionRateUrl = baseURL + 'promotion/createpromotion';
//get
const getProductRateUrl = baseURL + 'productbaserates/listproductbaseratesbyid';
const getRateSingleViewUrl = baseURL + 'productbaserates/displayratesinsingleview';
//delete urls
const deleteChildRateURL = baseURL + 'childprice/deletechildpricebyid';
const deleteInfantRateURL = baseURL + 'infantprice/deleteinfantpricebyid';
const deleteSeasonalRateURL = baseURL + 'supplement/deletesupplementbyid';
const deletePromotionRateURL = baseURL + 'promotion/deletepromotionbyid';


//update urls

const updateAdultPriceUrl = baseURL + 'adultprice/adultpriceprofileupdate'
const updateHourPriceUrl = baseURL + 'hourprice/hourpriceprofileupdate'
const updateVehiclePriceUrl = baseURL + 'vehicleprice/vehiclepriceprofileupdate'
const updateChildPriceUrl = baseURL + 'childprice/childpriceprofileupdate'
const updateInfantPriceUrl = baseURL + 'infantprice/infantpriceprofileupdate'
const updateSeasonalPriceUrl = baseURL + 'supplement/supplementprofileupdate'
const updatePromotionPriceUrl = baseURL + 'promotion/promotionprofileupdate'


//dashboard 

const dashboardDataUrl = baseURL + 'dashboard/DashboardCount';


//approval

const approveProductRatesURL = baseURL + 'productbaserates/approverates';
const rejectProductRatesURL = baseURL + 'productbaserates/rejectrates';


//currency
const listAllCurrencyUrl = baseURL + 'currency/listallcurrencies';
const createCurrencyUrl = baseURL + 'currency/createcurrency';
const getCurrencyUrl = baseURL + 'currency/getcurrenciesbyid';
const deleteCurrencyURL = baseURL + 'currency/deletecurrencies';
const currencyUpdateURL = baseURL + 'currency/currenciesupdate';
//city
const listAllCityUrl = baseURL + 'city/listallcities';
const createCityUrl = baseURL + 'city/createcity';
const getCityUrl = baseURL + 'city/getcitiesbyid';
const deleteCityURL = baseURL + 'city/deletecities';
const cityUpdateURL = baseURL + 'city/cititesupdate';
//ServiceType
const listAllServiceTypeUrl = baseURL + 'servicetype/listallservicetype';
const createServiceTypeUrl = baseURL + 'servicetype/createservicetype';
const getServiceTypeUrl = baseURL + 'servicetype/getservicetypebyid';
const deleteServiceTypeURL = baseURL + 'servicetype/deleteservicetype';
const serviceTypeUpdateURL = baseURL + 'servicetype/servicetypeupdate';



//ReservationEmail
const listAllReservationEmailUrl = baseURL + 'reservationmail/listallreservationmail';
const createReservationEmailUrl = baseURL + 'reservationmail/createreservationmail';
const getReservationEmailUrl = baseURL + 'reservationmail/getreservationmailbyid';
const deleteReservationEmailURL = baseURL + 'reservationmail/deletereservationmail';
const reservationEmailUpdateURL = baseURL + 'reservationmail/reservationmailupdate';




//TicketType
const listAllTicketTypeUrl = baseURL + 'tickettype/listalltickettype';
const createTicketTypeUrl = baseURL + 'tickettype/createtickettype';
const getTicketTypeUrl = baseURL + 'tickettype/getticketsbyid';
const deleteTicketTypeURL = baseURL + 'tickettype/deletetickettype';
const ticketTypeUpdateURL = baseURL + 'tickettype/tickettypeupdate';



//TourType
const listAllTourTypeUrl = baseURL + 'tourtype/listalltourtype';
const createTourTypeUrl = baseURL + 'tourtype/createtourtype';
const getTourTypeUrl = baseURL + 'tourtype/gettourtypebyid';
const deleteTourTypeURL = baseURL + 'tourtype/deletetourtype';
const tourTypeUpdateURL = baseURL + 'tourtype/tourtypeupdate';

//Supplier
const listAllSupplierUrl = baseURL + 'supplier/listallsuppliers';
const createSupplierUrl = baseURL + 'supplier/createsupplier';
const getSupplierUrl = baseURL + 'supplier/listsuppliersbyid';
const deleteSupplierURL = baseURL + 'supplier/deletesupplier';
const supplierUpdateURL = baseURL + 'supplier/supplierupdate';

//Product
const listAllProductUrl = baseURL + 'excursionproducts/listallproduct';
const createProductUrl = baseURL + 'excursionproducts/createproduct';
const getProductUrl = baseURL + 'excursionproducts/getproductsbyid';
const deleteProductURL = baseURL + 'excursionproducts/deleteproduct';
const productUpdateURL = baseURL + 'excursionproducts/productsupdate';


//Sub Product

const listAllSubProductUrl = baseURL + 'subproduct/listallsubproduct';
const listAllMainSubProductUrl = baseURL + 'subproduct/listallmainsubproduct';
const createSubProductUrl = baseURL + 'subproduct/createsubproduct';
const getSubProductUrl = baseURL + 'subproduct/getsubproductbyid';
const deleteSubProductURL = baseURL + 'subproduct/deletesubproduct';
const subproductUpdateURL = baseURL + 'subproduct/subproductupdate';

//Itenary


const createItenaryUrl = baseURL + 'itenary/createitenary';
const getItenaryUrl = baseURL + 'itenary/listitenarybyid';
const updateItenaryUrl = baseURL + 'itenary/itenaryprofileupdate';
const deleteInclusionURL = baseURL + 'serviceinclusion/deleteserviceinclusion';
const deleteExclusionURL = baseURL + 'serviceexclusion/deleteserviceexclusion';




//Product Image
const listAllProductImageUrl = baseURL + 'excursionproductimage/listallproductsimages';
const getProductImageUrl = baseURL + 'excursionproductimage/listproductimagesbyid';
const productImageUpdateURL = baseURL + 'excursionproductimage/productimageupdate';
const deleteProductImageURL = baseURL + 'excursionproductimage/deleteproductimages';


//SubProduct Image

//Product Image
const listAllSubProductImageUrl = baseURL + 'excursionsubproductimage/listallsubproductsimages';
const getSubProductImageUrl = baseURL + 'excursionsubproductimage/listsubproductimagesbyid';
const subproductImageUpdateURL = baseURL + 'excursionsubproductimage/subproductimageupdate';
const deleteSubProductImageURL = baseURL + 'excursionsubproductimage/deletesubproductimages';


//Paxhealth
const listAllPaxhealthUrl = baseURL + 'productpaxandhealth/listallproductpaxandhealth';
const createPaxhealthUrl = baseURL + 'productpaxandhealth/createproductpaxandhealth';
const getPaxhealthUrl = baseURL + 'productpaxandhealth/getproductpaxandhealthbyid';
const deletePaxhealthURL = baseURL + 'productpaxandhealth/deleteproductpaxandhealth';
const paxhealthUpdateURL = baseURL + 'productpaxandhealth/productpaxandhealthupdate';

//Age policy
const createProductAgePolicyUrl = baseURL + 'productagepolicy/createproductagepolicy';
const getAgePolicyUrl = baseURL + 'productagepolicy/getagepolicybyid';
const productagepolicyUpdateURL = baseURL + 'productagepolicy/agepolicyupdate';


//Occupancy Rule
const createProductOccupancyRuleUrl = baseURL + 'productoccupancyrule/createproductoccupancyrule';
const getOccupancyRuleUrl = baseURL + 'productoccupancyrule/getoccupancyrulebyid';
const productoccupancyruleUpdateURL = baseURL + 'productoccupancyrule/occupancyruleupdate';


//stop sale

const createStopSaleUrl = baseURL + 'stopsale/createstopsale';
const listAllStopSaleUrl = baseURL + 'stopsale/listallstopsale';
const deleteStopSaleURL = baseURL + 'stopsale/deletestopsale';
const getStopSaleUrl = baseURL + 'stopsale/getstopsalesbyid';
const stopsaleUpdateURL = baseURL + 'stopsale/stopsalesupdate';







//Cancellation Policy

const createProductCancelPolicyUrl = baseURL + 'prodcancelpolicy/createprodcancelpolicy';
const getCancelPolicyUrl = baseURL + 'prodcancelpolicy/getprodcancelpolicybyid';
const productcancelpolicyUpdateURL = baseURL + 'prodcancelpolicy/prodcancelpolicyupdate';

//Menu
const listAllMenuUrl = baseURL + 'menu/listallmenus';
const createMenuUrl = baseURL + 'menu/createmenu';
const getMenuUrl = baseURL + 'menu/getmenusbyid';
const deleteMenuURL = baseURL + 'menu/deletemenu';
const menuUpdateURL = baseURL + 'menu/menuupdate';

// role permission
const getCombinedRolePermissionUrl = baseURL + 'displayrolepermission/listrolepermission';
const createRolePermissionUrl = baseURL + 'userpermission/createuserpermission';
const listAllRolePermissionUrl = baseURL + 'userpermission/listalluserpermissions';
const getRolePermissionUrl = baseURL + 'userpermission/listalluserpermissionbyid';
const rolePermissionUpdateUrl = baseURL + 'userpermission/userpermissionprofileupdate';
const deletePermissionUrl = baseURL + 'userpermission/deleteuserpermission';


let authTokens = localStorage.getItem('crmSite') ? JSON.parse(localStorage.getItem('crmSite')) : null;

const axiosIntsance = axios.create({
    baseURL,
    headers: { Authorization: `${authTokens?.access}` }
});

axiosIntsance.interceptors.request.use(async req => {
    //check token exists
    if (!authTokens) {
        //get from localstorage 
        authTokens = localStorage.getItem('crmSite') ? JSON.parse(localStorage.getItem('crmSite')) : null;
        //store to headers
        req.headers.Authorization = `${authTokens?.accessJWT}`

    }

    //decode token
    const user = jwt_decode(authTokens.access);
    //check token expired
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
    console.log('isExpired: ', isExpired)
    //not expired continue
    if (!isExpired) return req

    // if expired call for refresh token
    //new refresh token
    const response = await axios.post(`${refreshTokenURL}`, {
        refreshtoken: authTokens.refreshJWT
    })
    //console.log("response");
    //console.log(response);

    //update to localstorage
    // localStorage.setItem('crmSite', JSON.stringify(response.data))
    localStorage.setItem('crmSite', JSON.stringify({ refreshJWT: authTokens.refreshJWT, access: response.data.token }))


    //update to header
    // req.headers.Authorization = `${response.data.token}`

    //update to header
    req.headers.Authorization = `${response.data.token}`
    return req
})



//Request interceptor for API calls
/* axiosIntsance.interceptors.request.use(
    async config => {
        const value = await redisClient.get(rediskey)
        const keys = JSON.parse(value)
        config.headers={
            'Authorization': `Bearer ${keys.accessJWT}`,
            'Accept': 'applicatio /json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        return config;
    },
    error => {
        Promise.reject(error)
    }); */

//Response interceptor for API calls
/* axiosIntsance.interceptors.response.use((response) => {
    return response
}, async function (error){
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry=true;
        const access_token = await refreshAccessToken();
        axios.defaults.headers.common['Authorization']= 'Bearer '+ access_token;
        return axiosIntsance(originalRequest);
    }
    return Promise.reject(error);
}); */


// user login 
export const userLogin = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            const res = await axios.post(loginUrl, frmData);
            /* console.log('Res print ');
           console.log(res);
           console.log('Res data print ');
           console.log(res.data);  */

            // console.log('success status ' + res.data.success);
            if (res.data.success === true) {
                sessionStorage.setItem('accessJWT', res.data.token);
                sessionStorage.setItem('accessIsLogIn', res.data.success);
                sessionStorage.setItem('accessUserID', res.data.id);
                localStorage.setItem(
                    'crmSite',
                    JSON.stringify({ refreshJWT: res.data.refreshtoken, access: res.data.token })
                );
                localStorage.setItem(
                    'accessIsLogIn',
                    JSON.stringify(res.data.success)
                );
                localStorage.setItem(
                    'accessUserID',
                    JSON.stringify(res.data.id)
                );
                localStorage.setItem(
                    'accessJWT',
                    JSON.stringify(res.data.token)
                );
                localStorage.setItem(
                    'accessRoleId',
                    JSON.stringify(res.data.role)
                );
                

            }
            resolve(res.data);

        } catch (error) {

            reject(error);
        }
    })
}

//fetch single user data
export const fetchUser = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            const accessUserID = localStorage.getItem('accessUserID');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }

            /*  const res = await axios.get(userProfileUrl+'/'+accessUserID, {
                signal:controller.signal,
                headers: {
                    'Authorization': accessJWT,
                }
            });  */

            let res = await axiosPrivate.get(userProfileUrl + '/' + accessUserID);
            if (res.status === 200) {
                resolve(res.data);
            }

            /*   console.log('Res print ');
              console.log(res);
              console.log('Res data print ');
              console.log(res.data); 
              console.log('Res data user print ');
              console.log(res.data.user);  */
            //  resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);


        }
    })
}

export const userLogout = async () => {
    try {
        /*  await axios.delete(logoutUrl, {
             headers:{
                 Authorization: sessionStorage.getItem("accessJWT"),
             }
         }) */

        await axiosPrivate.delete(logoutUrl);

    } catch (error) {
        console.log(error);

    }
}

// create new user
export const userCreation = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            axiosIntsance.defaults.headers.common['Content-Type'] = 'multipart/form-data';
            let res = await axiosPrivate.post(userCreateUrl, frmData);
            /*  const res = await axios.post(userCreateUrl, frmData , {
                 headers:{
                     
                     'Content-Type': 'application/json'
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}

// fetch All User List
export const fetchAllUser = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }

            let res = await axiosPrivate.get(listAllUsersUrl);
            /* const res = await axios.get(listAllUsersUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            /*   console.log('Res print ');
              console.log(res);
              console.log('Res data print ');
              console.log(res.data); 
              console.log('Res data user print ');
              console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// fetch new access key
export const fetchNewAccessJWT = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const { refreshJWT } = JSON.parse(localStorage.getItem("crmSite"));

            if (!refreshJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(newAccessJWT);
            /* const res = await axios.get(newAccessJWT, {
              headers: {
                Authorization: refreshJWT,
              },
            }); */

            if (res.data.status === "success") {
                sessionStorage.setItem("accessJWT", res.data.accessJWT);
            }

            resolve(true);
        } catch (error) {
            if (error.message === "Request failed with status code 403") {
                localStorage.removeItem("crmSite");
            }

            reject(false);
        }
    });
};


//UserProfile Modify

export const userProfileModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            const accessJWT = sessionStorage.getItem('accessJWT');
            // axiosIntsance.defaults.headers.common['Content-Type'] = 'multipart/form-data';
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.put(userProfileUpdate, frmData);
            /* const res = await axios.put(userProfileUpdate, frmData, {
                headers: {
                    'Authorization': accessJWT,
                    "Content-Type": "multipart/form-data",
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error.response.data);
            reject(error.response.data);
        }
    })
}

//User Delete

export const userDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            console.log('api delete call ' + id);
            let res = await axiosPrivate.delete(deleteUser + '/' + id);
            /* const res = await axios.delete(deleteUser+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



// fetch All user Roles
export const fetchAllUserRole = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllUserRoleUrl);
            /*  const res = await axios.get(listAllUserRoleUrl, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            /*   console.log('Res print ');
              console.log(res);
              console.log('Res data print ');
              console.log(res.data); 
              console.log('Res data user print ');
              console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new user
export const userRoleCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axios.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(userRoleCreateUrl, frmData);
            /*  const res = await axios.post(userRoleCreateUrl, frmData , {
                 headers:{
                     'Authorization': accessJWT,
                     'Content-Type': 'application/json'
                 }
             });  *//* .then(res => {
                // Work with the response...
               
            }).catch(err => {
                // Handle error
                console.log('err '+err.message);
            }) */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);
            /* if (error.response) {
                // The client was given an error response (5xx, 4xx)
                console.log('response '+error.response.message);
            } else if (error.request) {
                console.log('request '+error.request);
                // The client never received a response, and the request was never left
            } else {
                // Anything else
                console.log('Anything else');
            } */
        }
    })
}


// Fetch Single user Data

//fetch single Role data
export const fetchSingleUser = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            //console.log(id+"id user...");
            if (!accessJWT) {
                reject("Token not found!");
            }

            let res = await axiosPrivate.get(getUserUrl + '/' + id);
            /* const res = await axios.get(getUserUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('user Res print ');
            console.log(res);
            // console.log('Res data print ');
            // console.log(res.data); 
            // console.log('Res data user print ');
            // console.log(res.data.user);  
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);

        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify user 
/* export const userModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            const accessJWT = sessionStorage.getItem('accessJWT');
            const res = await axios.put(userUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            });

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);
                
            }
           

        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
} */

//fetch single Role data
export const fetchSingleUserRole = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getUserRoleUrl + '/' + id);
            /* const res = await axios.get(getUserRoleUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            //   console.log('Res print ');
            // console.log(res);
            // console.log('Res data print ');
            // console.log(res.data); 
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify user role
export const userRoleModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(userRoleUpdateURL, frmData);
            /* const res = await axios.put(userRoleUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//User Role Delete

export const userRoleDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteUserRolesURL + '/' + id);
            /*  const res = await axios.delete(deleteUserRolesURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


// Country List
export const fetchAllCountry = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllCountryUrl);
            /*  const res = await axios.get(listAllCountryUrl, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            console.log('Res print ');
            console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


// Product Commission List


// Country List
export const fetchAllProductCommission = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllProductComissionUrl);
            /*  const res = await axios.get(listAllCountryUrl, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            console.log('Res print ');
            console.log(res.data);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//dashboard

export const fetchAllDashboardData = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(dashboardDataUrl);
            /*  const res = await axios.get(listAllCountryUrl, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            console.log('Res print ');
            console.log(res.data);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new Country
export const countryCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createCountryUrl, frmData);
            /* const res = await axios.post(createCountryUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// add new product commission
export const productcommissionCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductComissionUrl, frmData);
            /* const res = await axios.post(createCountryUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}



// add new product rates
export const productratesCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductRatesUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}



// add new product adult rate
export const adultrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createAdultRatesUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}



//add new hourly rates

export const hourrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createHourRatesUrl, frmData);


            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}


//add new vehicle rates

export const vehiclerateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createVehicleRatesUrl, frmData);


            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}


// add new product child rate
export const childrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createChildRatesUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// add new product infant rate
export const infantrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createInfantRatesUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// add new product seasonal rate
export const seasonalrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createSuplementRatesUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// add new product promotion rate
export const promotionrateCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createPromotionRateUrl, frmData);


            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}



//fetch single Country data
export const fetchSingleCountry = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getCountryUrl + '/' + id);

            console.log('Res print ');
            console.log(res);
            resolve(res.data);



        } catch (error) {
            reject(error.message);
        }
    })
}




//fetch single Product Commission data
export const fetchSingleProductCommission = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getProductComissionUrl + '/' + id);

            console.log('Res print ');
            console.log(res);

            resolve(res.data);

        } catch (error) {
            reject(error.message);
        }
    })
}



//fetch all rates based on id data
export const fetchSingleProductRate = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getProductRateUrl + '/' + id);
            /*  const res = await axios.get(getCountryUrl+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            console.log('Res print ');
            console.log(res);
            // console.log('Res data print ');
            // console.log(res.data); 
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}



//fetch rate single view
export const fetchRateSingleView = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getRateSingleViewUrl + '/' + id);
        
            resolve(res.data);


        } catch (error) {
            reject(error.message);
        }
    })
}



//fetch qll itneary based on id data
export const fetchSingleProductItenary = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getItenaryUrl + '/' + id);

            console.log('Res print ');
            console.log(res);

            resolve(res.data);
        } catch (error) {
            reject(error.message);
        }
    })
}
// Modify country
export const countryModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');

            let res = await axiosPrivate.put(countryUpdateURL, frmData);
            /*  const res = await axios.put(countryUpdateURL, frmData, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

// Modify Product Commission
export const productcommissionModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');

            let res = await axiosPrivate.put(productcomissionUpdateURL, frmData);
            /*  const res = await axios.put(countryUpdateURL, frmData, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}




// Modify Product adult Rates
export const adultrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateAdultPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



//modify hour rate

export const hourrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateHourPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


// modify vehicle rates


export const vehiclerateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateVehiclePriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


// Modify Product child Rates
export const childrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateChildPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


// Modify Product infant Rates
export const infantrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateInfantPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



// Modify Product suppliment Rates
export const seasonalrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateSeasonalPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



// Modify Itenary
export const itenaryModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updateItenaryUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}





// Modify Product Promotion Rates
export const promotionrateModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(updatePromotionPriceUrl, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}






//Country Delete

export const countryDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteCountryURL + '/' + id);
            /*  const res = await axios.delete(deleteCountryURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//Product Commission Delete

export const productcommissionDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteProductComissionURL + '/' + id);
            /*  const res = await axios.delete(deleteCountryURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//Product Commission Approve

export const productcommissionApprove = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.put(approveProductComissionURL + '/' + id);
            /*  const res = await axios.delete(deleteCountryURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}





//Product Rates Approve

export const productratesApprove = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.put(approveProductRatesURL + '/' + id);
            /*  const res = await axios.delete(deleteCountryURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



//Product Commission reject

export const productcommissionReject = (frmData) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.put(rejectProductComissionURL, frmData);
            /*  const res = await axios.delete(deleteCountryURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Product Rates reject

export const productratesReject = (frmData) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(rejectProductRatesURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


// Currency List
// fetch All Currency
export const fetchAllCurrency = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllCurrencyUrl);
            /* const res = await axios.get(listAllCurrencyUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res print ');
            console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new Currency
export const currencyCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createCurrencyUrl, frmData);
            /* const res = await axios.post(createCurrencyUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//fetch single Currency data
export const fetchSingleCurrency = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getCurrencyUrl + '/' + id);
            /*  const res = await axios.get(getCurrencyUrl+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            console.log('Res print ');
            console.log(res);
            // console.log('Res data print ');
            // console.log(res.data); 
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify currency
export const currencyModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(currencyUpdateURL, frmData);
            /* const res = await axios.put(currencyUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Currency Delete

export const currencyDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteCurrencyURL + '/' + id);
            /* const res = await axios.delete(deleteCurrencyURL+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Child Rate Delete

export const childrateDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteChildRateURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Infant Rate Delete

export const infantrateDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteInfantRateURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Seasonal Rate Delete

export const seasonalrateDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteSeasonalRateURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Inclusion Delete

export const inclusionDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteInclusionURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}




//Exclusion Delete

export const exclusionDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteExclusionURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



//Promotion Rate Delete

export const promotionrateDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deletePromotionRateURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}

// City List
// fetch All City
export const fetchAllCity = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllCityUrl);
            /* const res = await axios.get(listAllCityUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res City print ');
            console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new City
export const cityCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createCityUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// create age policy


export const productagepolicyCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductAgePolicyUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// create occupancy rule


export const productoccupancyruleCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductOccupancyRuleUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}



// create cancel policy


export const productcancelpolicyCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductCancelPolicyUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//fetch single City data
export const fetchSingleCity = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getCityUrl + '/' + id);
            /* const res = await axios.get(getCityUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res print ');
            console.log(res);
            // console.log('Res data print ');
            // console.log(res.data); 
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch single Age policy data

export const fetchSingleAgePolicy = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getAgePolicyUrl + '/' + id);
            resolve(res.data);


        } catch (error) {
            reject(error.message);
        }
    })
}



//fetch single Occupancy rule data

export const fetchSingleOccupancyRule = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getOccupancyRuleUrl + '/' + id);
            resolve(res.data);


        } catch (error) {
            reject(error.message);
        }
    })
}

//fetch single Cancel policy data

export const fetchSingleCancelPolicy = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getCancelPolicyUrl + '/' + id);
            resolve(res.data);


        } catch (error) {
            reject(error.message);
        }
    })
}
// Modify city
export const cityModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(cityUpdateURL, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

//modify age policy

export const productagepolicyModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(productagepolicyUpdateURL, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



//modify occupancy rule

export const productoccupancyruleModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(productoccupancyruleUpdateURL, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

//modify cancel policy


export const productcancelpolicyModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(productcancelpolicyUpdateURL, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//City Delete

export const cityDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //   const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteCityURL + '/' + id);
            /* const res = await axios.delete(deleteCityURL+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}

// Service Type List
// fetch All ServiceType
export const fetchAllServiceType = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllServiceTypeUrl);
            /* const res = await axios.get(listAllServiceTypeUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res ServiceType print ');
            console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


// Reservation Email List
// fetch All ReservationEmail


export const fetchAllReservationEmail = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllReservationEmailUrl);
            /* const res = await axios.get(listAllServiceTypeUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */


            console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch all TicketType


export const fetchAllTicketType = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllTicketTypeUrl);



            console.log(res);

            resolve(res.data);




        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}



//fetch all tour type


export const fetchAllTourType = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');

            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllTourTypeUrl);



            console.log(res);

            resolve(res.data);




        } catch (error) {
            reject(error.message);
        }
    })
}

// create new ServiceType
export const serviceTypeCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createServiceTypeUrl, frmData);
            /* const res = await axios.post(createServiceTypeUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//create new ReservationEmail

export const reservationEmailCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createReservationEmailUrl, frmData);
            /* const res = await axios.post(createReservationEmailUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

// create new ticket type

export const ticketTypeCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createTicketTypeUrl, frmData);


            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}

//create new tour type

export const tourTypeCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createTourTypeUrl, frmData);


            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}



//fetch single ReservationEmail data

export const fetchSingleReservationEmail = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getReservationEmailUrl + '/' + id);
            /* const res = await axios.get(getServiceTypeUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res single service print ');
            console.log(res);
            console.log('Res data print ');
            console.log(res.data);
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch single ticket type data

export const fetchSingleTicketType = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getTicketTypeUrl + '/' + id);

            resolve(res.data);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}



//fetch single tour type data

export const fetchSingleTourType = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getTourTypeUrl + '/' + id);

            resolve(res.data);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch single ServiceType data
export const fetchSingleServiceType = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getServiceTypeUrl + '/' + id);
            /* const res = await axios.get(getServiceTypeUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res single service print ');
            console.log(res);
            console.log('Res data print ');
            console.log(res.data);
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify ServiceType
export const serviceTypeModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(serviceTypeUpdateURL, frmData);
            /* const res = await axios.put(serviceTypeUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

//Modify ReservationEmail

export const reservationEmailModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(reservationEmailUpdateURL, frmData);
            /* const res = await axios.put(reservationEmailUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Modify ticket Type

export const ticketTypeModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axiosPrivate.put(ticketTypeUpdateURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Modify tour Type

export const tourTypeModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axiosPrivate.put(tourTypeUpdateURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//ServiceType Delete

export const serviceTypeDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //  const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteServiceTypeURL + '/' + id);

            /*  const res = await axios.delete(deleteServiceTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//ReservationEmail Delete

export const reservationEmailDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //  const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteReservationEmailURL + '/' + id);

            /*  const res = await axios.delete(deleteServiceTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//ticket type delete

export const ticketTypeDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteTicketTypeURL + '/' + id);



            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



//tour type delete

export const tourTypeDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.delete(deleteTourTypeURL + '/' + id);



            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



// Supplier List
// fetch All Supplier
export const fetchAllSupplier = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllSupplierUrl);
            /* const res = await axios.get(listAllSupplierUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            // console.log('Res Supplier print ');
            // console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new Supplier
export const supplierCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createSupplierUrl, frmData);
            /* const res = await axios.post(createServiceTypeUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//fetch single Supplier data
export const fetchSingleSupplier = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getSupplierUrl + '/' + id);
            /* const res = await axios.get(getSupplierUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res single supplier  print ');
            console.log(res);
            console.log('Res data print ');
            console.log(res.data);
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify Supplier
export const supplierModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(supplierUpdateURL, frmData);
            /* const res = await axios.put(supplierUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Supplier Delete

export const supplierDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //  const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteSupplierURL + '/' + id);

            /*  const res = await axios.delete(deleteServiceTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}

//Pax health List
//fetch all pax health

export const fetchAllPaxhealth = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllPaxhealthUrl);

            resolve(res.data);



        } catch (error) {

            reject(error.message);
        }
    })
}



// Product List
// fetch All Product
export const fetchAllProduct = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllProductUrl);
            /* const res = await axios.get(listAllProductUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            // console.log('Res Supplier print ');
            // console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}



//fetch all stop sale

export const fetchAllStopSale = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllStopSaleUrl);

            resolve(res.data);

        } catch (error) {
            reject(error.message);
        }
    })
}



//fetch All Sub Product

export const fetchAllSubProduct = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllSubProductUrl);
            resolve(res.data);

        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch All Sub Products by Main Products


export const fetchAllMainSubProduct = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllMainSubProductUrl);
            resolve(res.data);

        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}



//fetch all product image

export const fetchAllProductImage = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllProductImageUrl);
            /* const res = await axios.get(listAllProductUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            // console.log('Res Supplier print ');
            // console.log(res);
            /*console.log('Res data print ');
            console.log(res.data); 
            console.log('Res data user print ');
            console.log(res.data.user);  */
            resolve(res.data);
            // console.log('success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

//fetch all subproduct image


export const fetchAllSubProductImage = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllSubProductImageUrl);
            resolve(res.data);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

//create new pax and health

export const paxhealthCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createPaxhealthUrl, frmData);
            /* const res = await axios.post(createServiceTypeUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

// create new Product 
export const productCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createProductUrl, frmData);
            /* const res = await axios.post(createServiceTypeUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}


// create a new stop sale

export const stopsaleCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createStopSaleUrl, frmData);

            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}


//create new sub product

export const subproductCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createSubProductUrl, frmData);

            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}



//create new itnery data

export const itenaryCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            axiosPrivate.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createItenaryUrl, frmData);

            resolve(res.data);
            if (res.data.status === 'success') {
                resolve(res.data);

            }


        } catch (error) {
            reject(error);

        }
    })
}



//fetch single Product data
export const fetchSingleProduct = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getProductUrl + '/' + id);
            /* const res = await axios.get(getProductUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res single Product print ');
            console.log(res);
            console.log('Res data print ');
            console.log(res.data);
            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}


//fetch single Stop Sale data
export const fetchSingleStopSale = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getStopSaleUrl + '/' + id);
            resolve(res.data);



        } catch (error) {
            reject(error.message);
        }
    })
}


// fetch single Sub Product Data

export const fetchSingleSubProduct = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getSubProductUrl + '/' + id);

            resolve(res.data);
            console.log(res.data)
            console.log("sjsjhshhh")

        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

//fetch single Product Image Data

export const fetchSingleProductImage = (id) => {
    console.log("pennnn", id)
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');

            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getProductImageUrl + '/' + id);

            resolve(res.data);




        } catch (error) {

            reject(error.message);
        }
    })
}


//fetch sinlge Sub Product Image Data

export const fetchSingleSubProductImage = (id) => {
    console.log("pennnn", id)
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');

            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getSubProductImageUrl + '/' + id);

            resolve(res.data);




        } catch (error) {

            reject(error.message);
        }
    })
}



//fetch single pax health 

export const fetchSinglePaxhealth = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getPaxhealthUrl + '/' + id);


            /* console.log('Res data user print ');
             console.log(res.data.user);  */
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify Product
export const productModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //  const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(productUpdateURL, frmData);
            /* const res = await axios.put(productUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



//Modify Stop Sale

export const stopsaleModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axiosPrivate.put(stopsaleUpdateURL, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



// modify Sub Product

export const subproductModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axiosPrivate.put(subproductUpdateURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//modify product image

export const productImageModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(productImageUpdateURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//modify sub product image

export const subproductImageModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {

            let res = await axiosPrivate.put(subproductImageUpdateURL, frmData);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}



// Modify Pax Health

export const paxhealthModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //  const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(paxhealthUpdateURL, frmData);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Product Delete

export const productDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //    const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteProductURL + '/' + id);

            /*  const res = await axios.delete(deleteProductTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



//Stop Sale Delete

export const stopsaleDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
          
            let res = await axiosPrivate.delete(deleteStopSaleURL + '/' + id);

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//Sub Product Delete

export const subproductDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axiosPrivate.delete(deleteSubProductURL + '/' + id);



            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//Product Image Delete
export const productImageDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //    const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteProductImageURL + '/' + id);

            /*  const res = await axios.delete(deleteProductTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


//Sub Product Image Delete

export const subproductImageDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
          
            let res = await axiosPrivate.delete(deleteSubProductImageURL + '/' + id);


            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}



//Pax health Delete


export const paxhealthDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //    const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deletePaxhealthURL + '/' + id);

            /*  const res = await axios.delete(deleteProductTypeURL+'/'+id, {
                 headers: {
                     'Authorization': accessJWT,
                 }
             }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}

// Menu List
// fetch All Menu
export const fetchAllMenu = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllMenuUrl);
            /* const res = await axios.get(listAllCityUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res City print ');
            console.log(res);
            resolve(res.data);




        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// create new Menu
export const menuCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createMenuUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//fetch single Menu data
export const fetchSingleMenu = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getMenuUrl + '/' + id);
            /* const res = await axios.get(getCityUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log(res);
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}
// Modify menu
export const menuModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(menuUpdateURL, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


//Menu Delete

export const menuDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //   const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deleteMenuURL + '/' + id);
            /* const res = await axios.delete(deleteCityURL+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
        }
    })
}


// create new Role Permission

export const rolePermissionCreation = frmData => {
    return new Promise(async (resolve, reject) => {

        try {
            // const accessJWT = sessionStorage.getItem('accessJWT');
            axiosIntsance.defaults.headers.common['Content-Type'] = 'application/json';
            let res = await axiosPrivate.post(createRolePermissionUrl, frmData);
            /* const res = await axios.post(createCityUrl, frmData , {
                headers:{
                    'Authorization': accessJWT,
                    'Content-Type': 'application/json'
                }
            });  */

            resolve(res.data);
            // console.log('api success  '+res.data.status);
            if (res.data.status === 'success') {
                //console.log('api '+res.data.message);
                resolve(res.data);

            }


        } catch (error) {
            // console.log('api '+error);
            reject(error);

        }
    })
}

//fetch all role permission

export const fetchAllRolePermission = () => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(listAllRolePermissionUrl);
            /* const res = await axios.get(listAllCityUrl, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log('Res City print ');
            console.log(res);
            resolve(res.data);




        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

//Get all role permission by id
export const getSingleRolePermission = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getRolePermissionUrl + '/' + id);
            /* const res = await axios.get(getCityUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log(res);
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}

// Modify role permission

export const rolePermissionModify = frmData => {
    return new Promise(async (resolve, reject) => {
        try {
            //const accessJWT = sessionStorage.getItem('accessJWT');
            let res = await axiosPrivate.put(rolePermissionUpdateUrl, frmData);
            /* const res = await axios.put(cityUpdateURL, frmData, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}
// Delete role permission
export const permissionDelete = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            //   const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log('api delete call '+id);
            let res = await axiosPrivate.delete(deletePermissionUrl + '/' + id);
            /* const res = await axios.delete(deleteCityURL+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */
            console.log("dlete", res)
            resolve(res.data);

            if (res.data.success === true) {
                resolve(res.data);

            }


        } catch (error) {

            reject(error);
            console.log(error);
        }
    })
}

//Get combined all role permission by id
export const getCombinedRolePermission = (id) => {
    return new Promise(async (resolve, reject) => {
        try {

            const accessJWT = sessionStorage.getItem('accessJWT');
            // console.log(accessJWT);
            if (!accessJWT) {
                reject("Token not found!");
            }
            let res = await axiosPrivate.get(getCombinedRolePermissionUrl + '/' + id);
            /* const res = await axios.get(getCityUrl+'/'+id, {
                headers: {
                    'Authorization': accessJWT,
                }
            }); */

            console.log(res);
            resolve(res.data);
            //  console.log('role success status ' + res.data.success);



        } catch (error) {
            //console.log(error);
            reject(error.message);
        }
    })
}





/* const Login = () => {

    const emailInputRef = useRef();
    const passwordInputRef = useRef();
    const authctx = useContext(AuthContext);
    const [isLogin, setLogin] = useState(true);
    const navigate = useNavigate();
    const submitHandler = (event) => {

        event.preventDefault();
        const enteredemail = emailInputRef.current.value;
        const enteredpassword = passwordInputRef.current.value;

        //optional validation

        if (!isLogin) {
            console.log('Testing');
        } else {
            let url = 'http://localhost:34567/auth/adminLogin';
            fetch(url,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        email: enteredemail,
                        password: enteredpassword,
                        returnSecureToken: true
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    }


                }

            ).then(res => {
                if (res.ok) {
                    return res.json();
                    //
                } else {

                    return res.json().then((data) => {
                        let errormessage = 'Authentication Failed';
                        throw new Error(errormessage);
                        //console.log(data);

                    })
                }

            }).then((data) => {
                authctx.login(data.idToken);
                setLogin(true);
                navigate('/dashboard');
            }).catch((err) => {
                alert(err.message);

            })

        }
    }; */


export default axiosIntsance;